import { forwardRef } from "react";
function SvgRawLookingForSomethingIcon({ title, titleId, ...props }, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 240 240"
      role="img"
      ref={ref}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        fill="#DEECFF"
        d="M236.596 130.501c8.449 37.929-17.542 66.439-36.925 73.4-31.293 11.238-84.491 9.482-121.73 6.321-37.238-3.161-75.224-18.613-77.679-49.167-2.454-30.554 12.687-32.402 31.549-62.33C50.739 68.69 42.483 31.361 94.116 24.688c51.633-6.673 55.39 37.017 84.179 50.012 28.79 12.994 49.852 17.87 58.301 55.8Z"
      />
      <circle cx={133.652} cy={158.348} r={24.652} fill="#B3D3FF" />
      <circle cx={191.174} cy={163.826} r={19.174} fill="#B3D3FF" />
      <circle cx={166.522} cy={139.174} r={19.174} fill="#B3D3FF" />
      <path fill="#B3D3FF" d="M133.652 151.5h57.522V183h-57.522z" />
      <path
        fill="#fff"
        d="M123.092 36.462a3.766 3.766 0 0 1-.081 5.33 3.779 3.779 0 0 1-5.338-.081 3.766 3.766 0 0 1 .081-5.33 3.779 3.779 0 0 1 5.338.08Z"
      />
      <path
        fill="#80B5FF"
        d="M127.83 49.677c.452.466.44 1.21-.026 1.66-.466.452-1.21.44-1.663-.025a1.174 1.174 0 0 1 .026-1.66 1.177 1.177 0 0 1 1.663.025Z"
        opacity={0.5}
      />
      <path
        fill="#fff"
        d="M65.165 58.614c.452.466.44 1.21-.026 1.661-.466.452-1.21.44-1.663-.025a1.173 1.173 0 0 1 .026-1.66 1.177 1.177 0 0 1 1.663.024ZM57.165 74.27c.452.466.44 1.21-.026 1.661-.466.452-1.21.44-1.663-.025a1.173 1.173 0 0 1 .026-1.66 1.177 1.177 0 0 1 1.663.025ZM60.889 182.264a2.346 2.346 0 0 1-.05 3.321 2.353 2.353 0 0 1-3.327-.05 2.346 2.346 0 0 1 .051-3.321 2.353 2.353 0 0 1 3.326.05Z"
      />
      <path
        fill="#fff"
        d="m13.172 129.998 3.417 4.361a.87.87 0 0 0 .748.329l5.457-.401a.885.885 0 0 1 .817.442.914.914 0 0 1-.02.943l-3.01 4.662a.927.927 0 0 0-.08.831l2.064 5.173a.91.91 0 0 1-.156.931.866.866 0 0 1-.888.268l-5.274-1.481a.87.87 0 0 0-.8.182l-4.147 3.596a.857.857 0 0 1-.916.139.88.88 0 0 1-.372-.313.903.903 0 0 1-.154-.466l-.252-5.579a.907.907 0 0 0-.412-.716l-4.648-2.947a.908.908 0 0 1-.232-1.303.867.867 0 0 1 .387-.292l5.115-1.973a.88.88 0 0 0 .543-.621l1.31-5.421a.9.9 0 0 1 .241-.406.865.865 0 0 1 1.262.062ZM107.589 57.247l2.186 2.684a.57.57 0 0 0 .48.203l3.492-.247a.573.573 0 0 1 .523.272.547.547 0 0 1-.014.58l-1.926 2.869a.56.56 0 0 0-.051.511l1.321 3.184a.534.534 0 0 1-.099.573.565.565 0 0 1-.569.164l-3.375-.91a.576.576 0 0 0-.512.11l-2.654 2.214a.566.566 0 0 1-.825-.107.549.549 0 0 1-.098-.287l-.162-3.433a.558.558 0 0 0-.263-.44l-2.975-1.814a.556.556 0 0 1-.262-.521.549.549 0 0 1 .361-.46l3.274-1.215a.565.565 0 0 0 .348-.382l.838-3.336a.556.556 0 0 1 .417-.387.57.57 0 0 1 .545.175ZM186.453 173.447l2.187 2.683a.557.557 0 0 0 .479.203l3.492-.247a.569.569 0 0 1 .523.272.537.537 0 0 1-.013.58l-1.926 2.869a.56.56 0 0 0-.051.512l1.321 3.183a.54.54 0 0 1-.1.573.563.563 0 0 1-.568.165l-3.376-.912a.573.573 0 0 0-.512.112l-2.654 2.213a.564.564 0 0 1-.824-.107.539.539 0 0 1-.099-.286l-.161-3.434a.553.553 0 0 0-.264-.44l-2.974-1.814a.551.551 0 0 1-.262-.521c.01-.102.049-.2.113-.281a.566.566 0 0 1 .248-.18l3.273-1.214a.545.545 0 0 0 .348-.382l.839-3.336a.54.54 0 0 1 .154-.25.566.566 0 0 1 .807.039ZM224.924 143.604l-1.439 2.365a.456.456 0 0 0-.035.411l.999 2.592a.495.495 0 0 1-.094.449.438.438 0 0 1-.186.133.42.42 0 0 1-.222.019l-2.536-.728a.427.427 0 0 0-.382.089l-2.003 1.812a.42.42 0 0 1-.431.045.446.446 0 0 1-.176-.147.48.48 0 0 1-.086-.22l-.134-2.795a.47.47 0 0 0-.057-.206.429.429 0 0 0-.143-.153l-2.22-1.471a.437.437 0 0 1-.159-.181.464.464 0 0 1 .042-.473.427.427 0 0 1 .188-.146l2.456-.993a.446.446 0 0 0 .164-.126.503.503 0 0 0 .094-.191l.621-2.719a.478.478 0 0 1 .125-.198.43.43 0 0 1 .422-.1.44.44 0 0 1 .191.123l1.648 2.18a.391.391 0 0 0 .359.166l2.626-.208a.393.393 0 0 1 .213.056.434.434 0 0 1 .157.164.474.474 0 0 1-.002.451Z"
        opacity={0.8}
      />
      <path fill="#80B5FF" d="M101 57h3v140h-3z" />
      <path
        fill="#80B5FF"
        d="M101 80h38v3h-38zM101 113h38v3h-38zM101 146h38v3h-38zM101 179h38v3h-38z"
      />
      <path fill="#80B5FF" d="M137 57h3v124h-3z" />
      <path
        fill="#A6735B"
        d="M113.172 116.921c.467-2.333.195-5.638 0-6.999h5.541c0 5.541-.583 12.248-.875 17.497-.233 4.199-.874 11.082-1.166 13.998h-3.5c0-1.361-.116-5.483-.583-11.082-.583-6.999 0-10.498.583-13.414ZM123.004 123.628c-.467-4.199.194-10.887.583-13.706h4.958c.097 2.722.291 9.448.291 14.581V142h-3.208c-.68-4.374-2.158-14.173-2.624-18.372ZM129.504 39.06c0-2.8-1.556-4.472-2.333-4.958h-7.874v15.455h4.957v-3.499h3.5c2.041 0 1.75-3.5 1.75-6.999Z"
      />
      <path
        fill="#04337A"
        d="M135.627 37.598h1.166v3.499h-1.166zM150.208 35.266h1.166v8.165h-1.166zM136.793 38.183l13.414-1.75v5.833l-13.414-1.75v-2.333Z"
      />
      <path
        fill="#A6735B"
        d="M139.127 41.393c.233 1.166.68 3.013.874 3.791h2.042c0-5.133 2.333-7.582 3.499-8.165-.583-2.042-2.333-2.042-4.082-1.167-1.75.875-2.625 4.083-2.333 5.541Z"
      />
      <path
        fill="#106FF3"
        d="M131.545 75.512c-.933-5.133-.972-9.137-.875-10.498 1.264.874 4.316 2.858 6.416 3.79 2.624 1.167 5.54 2.042 6.415-4.082.7-4.9-.097-15.845-.583-20.705-2.333-.7-3.888-.486-4.374-.292l-.875 16.04c-4.083-8.458-9.332-11.082-13.123-11.957-3.791-.875-7.291 0-9.332 2.041-2.041 2.042-10.498 19.83-10.207 22.747.234 2.333 4.18 6.027 6.124 7.582-1.166 8.632-1.263 24.982-1.166 32.078h23.913c-.292-18.08-1.167-30.328-2.333-36.744Z"
      />
      <path
        fill="#fff"
        d="m129.534 141-4.282 1.316c-.457 1.684-.19 3.158 0 3.684h12.561c.286-.351.457-1.211-1.142-1.842-1.598-.632-5.424-2.369-7.137-3.158ZM116.857 141h-3.714c-.914 2.118-1.143 4.216-1.143 5h6c0-1.647-.762-4.02-1.143-5Z"
      />
      <path
        fill="#04337A"
        d="M123.963 39.058c.7-3.5 2.625-4.763 3.499-4.957-2.333-2.042-6.707-3.208-10.498-.584-3.791 2.625-4.957 11.374-4.957 21.289 0 7.932-2.722 13.414-4.083 15.164 11.898-.233 14.095-19.15 13.706-28.579-.292-.486-.7-1.633 0-2.333.7-.7 1.847-.291 2.333 0Z"
      />
      <circle cx={57.544} cy={170.458} r={28.544} fill="#fff" />
      <circle cx={124.147} cy={176.799} r={22.201} fill="#fff" />
      <circle cx={95.603} cy={148.256} r={22.201} fill="#fff" />
      <path fill="#fff" d="M57.544 162.527h66.603V199H57.544z" />
      <circle cx={39.703} cy={92.296} r={10.703} fill="#fff" />
      <circle cx={64.676} cy={94.676} r={8.324} fill="#fff" />
      <circle cx={53.973} cy={83.973} r={8.324} fill="#fff" />
      <path fill="#fff" d="M39.703 89.324h24.973V103H39.703z" />
      <path
        fill="#80B5FF"
        d="M35.172 168.094a3.519 3.519 0 0 1-.075 4.981 3.532 3.532 0 0 1-4.99-.075 3.52 3.52 0 0 1 .077-4.982 3.53 3.53 0 0 1 4.988.076Z"
        opacity={0.5}
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgRawLookingForSomethingIcon);
export default ForwardRef;
